if (!customElements.get('product-description-collapse')) {
  customElements.define(
    'product-description-collapse',
    class ProductDescriptionCollapse extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-description-body]');
        this.toggle = this.querySelector('[data-description-toggle]');
        this.labelMore = this.querySelector('[data-label-more]');
        this.labelLess = this.querySelector('[data-label-less]');
        if (!this.body || !this.toggle) return;

        this.toggle.addEventListener('click', () => this.#toggle());
        this.#sync();
        if (typeof ResizeObserver !== 'undefined') {
          this.ro = new ResizeObserver(() => this.#sync());
          this.ro.observe(this.body);
        }
      }

      disconnectedCallback() {
        this.ro?.disconnect();
      }

      #toggle() {
        this.classList.toggle('is-expanded');
        this.#updateLabels();
      }

      #updateLabels() {
        const expanded = this.classList.contains('is-expanded');
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (this.labelMore) this.labelMore.toggleAttribute('hidden', expanded);
        if (this.labelLess) this.labelLess.toggleAttribute('hidden', !expanded);
      }

      #sync() {
        if (this.classList.contains('is-expanded')) {
          this.toggle.hidden = false;
          this.#updateLabels();
          return;
        }
        const overflows = this.body.scrollHeight > this.body.clientHeight + 4;
        this.toggle.hidden = !overflows;
        this.classList.toggle('is-collapsible', overflows);
        this.#updateLabels();
      }
    }
  );
}
